import React from 'react';
import { ArrowDown, ArrowUp, HelpCircle } from 'lucide-react';
import { TaapMetricValue } from '../../types/taap';
import { formatChange, isImprovement } from '../../utils/taapFormat';

interface Props {
  metricKey: string;
  label: string;
  /** 「獲得単価（低いほど良い）」のように読み手の解釈を助ける補足。 */
  hint?: string;
  metric: TaapMetricValue | null;
  formatValue: (value: number) => string;
  /** 目標との差など、前期間比の代わりに出す注記。 */
  note?: string;
}

const TaapKpiCard: React.FC<Props> = ({ metricKey, label, hint, metric, formatValue, note }) => {
  if (!metric) {
    return null;
  }

  const improved = isImprovement(metricKey, metric.change_rate);
  const changeColor =
    improved === null ? 'text-gray-400' : improved ? 'text-green-700' : 'text-red-700';

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4">
      <div className="flex items-center gap-1 text-xs font-medium text-gray-500">
        <span>{label}</span>
        {hint && (
          <span title={hint} className="cursor-help text-gray-300">
            <HelpCircle className="h-3.5 w-3.5" />
          </span>
        )}
      </div>

      <div className="mt-1.5 text-2xl font-bold tabular-nums text-gray-900">
        {formatValue(metric.value)}
      </div>

      <div className="mt-1 flex items-center gap-1 text-xs">
        {metric.change_rate !== null && improved !== null && (
          improved ? (
            <ArrowDown className={`h-3 w-3 ${changeColor} ${metricKey === 'cpa' || metricKey === 'cost' ? '' : 'rotate-180'}`} />
          ) : (
            <ArrowUp className={`h-3 w-3 ${changeColor} ${metricKey === 'cpa' || metricKey === 'cost' ? '' : 'rotate-180'}`} />
          )
        )}
        <span className={changeColor}>{formatChange(metric)}</span>
        {note && <span className="ml-1 text-gray-500">· {note}</span>}
      </div>
    </div>
  );
};

export default React.memo<Props>(TaapKpiCard);
